/**
 * Дэвсгэр зурагтай КАРТ БҮРИЙН нэгдсэн эффект.
 *
 * Эх загвар нь нүүр хуудасны «Тогтвортой хөгжлийн амлалт» (ESG) хэсэг —
 * захиалагч түүнийг жишиг болгохыг хүссэн. Өмнө нь дөрвөн компонент тус
 * тусдаа утга барьж байсан: процессын карт огт хөдөлгөөнгүй, ангиллын карт
 * зумгүй, агуулахын карт өөр хугацаатай. Тэдгээр нь салангид засагдвал
 * дахин зөрөх нь цаг хугацааны асуудал байсан тул энд ганц эх сурвалж болгов.
 *
 * Гурвуулаа хамт хэрэглэгдэнэ: гаднах хайрцагт SHELL, зурагт IMAGE,
 * бичгийн доорх бүрхүүлд SCRIM.
 */

/** Гаднах хайрцаг — `group` нь дотоод элементүүдийн hover-ийг хөтөлнө. */
export const IMAGE_CARD_SHELL = 'group relative overflow-hidden'

/** Зураг өөрөө — хулгана дээр очиход бага зэрэг томорно. */
export const IMAGE_CARD_IMAGE = 'object-cover transition-transform duration-500 group-hover:scale-105'

/**
 * Зургийн дээрх бараан бүрхүүл.
 *
 * Зураг нь янз бүрийн тод/бараан байдаг тул цагаан бичгийн уншигдац зөвхөн
 * зурагнаас хамаарах ёсгүй. Hover үед гүнзгийрэх нь картыг «идэвхжсэн» мэт
 * харагдуулна.
 */
export const IMAGE_CARD_SCRIM = 'absolute inset-0 bg-black/45 transition-colors duration-500 group-hover:bg-black/55'
